<template>
    
    <div>
    
      <section v-if="id_clube == '59'" class="setores">
          <div class="top">
              <div class="visitantes"></div>
              <div class="arquibancada"></div>
          </div>
          <div class="mid">
              <div class="barreira" v-if="nivel == 1" style="background: #d4af37; color: white;"> Setor Ouro </div>
              <div v-if="nivel == 2" :class="{'nivel-02': true, 'nivel': true, 'disabled': nivel == 1}">
                  <div class="secao" data-secao="201">
                      <div class="setor" @click="select(2, 'A1')">A1 (201)</div>
                  </div>
                  <div class="secao">
                      <div class="setor" @click="select(2, 'A2')">A2 (202)</div>
                  </div>
                  <div class="secao">
                      <div class="setor" @click="select(2, 'B')">B (203)</div>
                  </div>
                  <div class="secao">
                      <div class="setor" @click="select(2, 'C3')">C3 (203-1)</div>
                      <div class="setor" @click="select(2, 'C2')">C2 (204)</div>
                  </div>
                  <div class="secao">
                      <div class="setor" @click="select(2, 'C1')">C1 (205)</div>
                  </div>
              </div>
              <div v-if="nivel == 1" :class="{'nivel-01': true, 'nivel': true, 'disabled': nivel == 2}">
                  <div class="secao">
                      <div class="setor" @click="select(1, 'A1')">A1 (101-1)</div>
                      <div class="setor" @click="select(1, 'A2')">A2 (101-2)</div>
                  </div>
                  <div class="secao">
                      <div class="setor" @click="select(1, 'A3')">A3 (102-1)</div>
                      <div class="setor" @click="select(1, 'A4')">A4 (102-2)</div>
                  </div>
                  <div class="secao">
                      <div class="setor" @click="select(1, 'B')">B (103)</div>
                  </div>
                  <div class="secao">
                      <div class="setor" @click="select(1, 'C3')">C3 (104-1)</div>
                      <div class="setor" @click="select(1, 'C2')">C2 (104-2)</div>
                  </div>
                  <div class="secao">
                      <div class="setor" @click="select(1, 'C1')">C1 (105)</div>
                  </div>
              </div>
              <div class="barreira" v-if="nivel == 2"> Setor Prata </div>
              <div class="campo"></div>
              <div class="arquibancada"></div>
          </div>
          <div class="bottom">
              <div class="arquibancada"></div>
          </div>
      </section>

      <section v-if="id_clube == '94'" class="setores">
          <div class="top">
              <div class="visitantes"></div>
              <div class="arquibancada"></div>
          </div>
          <div class="mid">
              <div :class="{'nivel-02': true, 'nivel': true, 'disabled': nivel == 1}">
              	  <div class="secao" style="width: 30%;">
                      <div class="setor" style="background-color: #dddddd; cursor: not-allowed; filter: none;"></div>
                  </div>
                  <div class="secao" style="width: 35%;">
                      <div class="setor" @click="select(1, '1')">Setor 1</div>
                  </div>
                  <div class="secao" style="width: 35%;">
                      <div class="setor" @click="select(3, '3')">Setor 3</div>
                  </div>
              </div>
              <div class="campo" style="
                  background: url('https://storage.torcedordevantagens.com.br/doc/outros/7b9ca162-90b1-4c98-81f5-339d301e1f3c.png.png');
                  background-size: cover;
              "></div>
              <div :class="{'nivel-02': true, 'nivel': true, 'disabled': nivel == 1}">
              	  <div class="secao" style="width: 30%;">
                      <div class="setor" style="background-color: #dddddd; cursor: not-allowed; filter: none;"></div>
                  </div>
                  <div class="secao" style="width: 35%;">
                      <div class="setor" @click="select(2, '2', true)">Setor 2</div>
                  </div>
                  <div class="secao" style="width: 35%;">
                      <div class="setor" @click="select(4, '4', true)">Setor 4</div>
                  </div>
              </div>
          </div>
          <div class="bottom" style="width: 17%;">
              <div class="arquibancada" style="height: 33%; border-bottom-right-radius: 0px;">
                <div class="setor" @click="select(6, '6')" style="
                	cursor: pointer;
                    border-top-right-radius: 1000vw;
                    background-color: #d4af37;
                    height: 100%;
                    color: #fff;
                    text-align: center;
                    flex-grow: 1;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                ">Setor 6</div>
              </div>
              <div class="arquibancada" style="background-color: #fff;margin-top: 2px;display: flex;margin-bottom: 2px;flex-grow: 3 !important;border-top-right-radius: 0px;border-bottom-right-radius: 0px;justify-content: space-between;">
              	<div style="height: 100%;width: 50%;">
                  <div class="setor" @click="select(7, 'Lado A')" style="
                      cursor: pointer;
                      background-color: #d4af37;
                      height: 50%;
                      color: #fff;
                      text-align: center;
                      flex-grow: 1;
                      display: flex;
                      margin-bottom: 2px;
    				  margin-right: 1px;
                      align-items: center;
                      justify-content: center;
                  ">Setor 7 Lado A</div>
                  <div class="setor" @click="select(7, 'Lado B', true)" style="
                      cursor: pointer;
                      background-color: #d4af37;
                      height: 49.5%;
                      color: #fff;
                      text-align: center;
                      flex-grow: 1;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                  ">Setor 7 Lado B</div>
                </div>
                <div style="height: 100%;width: 50%;">
                  <div class="setor" @click="select(7, '7')" style="
                      cursor: pointer;
                      background-color: #d4af37;
                      height: 100%;
                      color: #fff;
                      text-align: center;
                      flex-grow: 1;
                      display: flex;
                      margin-left: 1px;
                      align-items: center;
                      justify-content: center;
                  ">Setor 7</div>
                </div>
              </div>
              <div class="arquibancada" style="height: 33%; border-top-right-radius: 0px;">
              	<div class="setor" @click="select(5, '5', true)" style="
                	cursor: pointer;
                    border-bottom-right-radius: 1000vw;
                    background-color: #d4af37;
                    height: 100%;
                    color: #fff;
                    text-align: center;
                    flex-grow: 1;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                ">Setor 5</div>
              </div>
          </div>
      </section>
      
   </div>

</template>

<script>

import Vue from 'vue'

export default Vue.extend({
    data() {
        return {}
    },
    props: {
        id_clube: {
            default: 0
        },
        value: {
            type: String,
            default: ''
        },
        nivel: {
            default: 0
        }
    },
    mounted() {
    	console.log('id_clube', this.id_clube);
        
        const but = document.querySelector('button.wizard-btn')
        if (but) {
            but.style.display = 'none'
        }
    },
    methods: {
        select(secao, setor, order = null) {
            const but = document.querySelector('button.wizard-btn')
            if (but) {
                but.style.display = 'inline-block'
            }
            
            if(order){
          		this.$emit('input', secao + '/' + setor + '/true')
            } else {
            	this.$emit('input', secao + '/' + setor)
            }
        }
    }
})

</script>

<style lang="scss">
    * {
        box-sizing: border-box;
    }

    section.setores {
        display: flex;
        height: 35vw;
        width: 50vw;
        margin-bottom: 50px;

        @media (max-aspect-ratio:1/1) {
            width: 120%;
            height: 80vh;
        }

        div.top {
            height: 100%;
            width: 8%;
            margin-right: 6px;
            display: flex;
            flex-direction: column;

            div.visitantes {
                flex-grow: 2;
                width: 100%;
                border-top-left-radius: 1000vw;
                background: #ddd;
                cursor: not-allowed;
            }

            div.arquibancada {
                background: #ddd;
                cursor: not-allowed;
                flex-grow: 4;
                width: 100%;
                border-bottom-left-radius: 1000vw;
            }
        }

        div.bottom {
            height: 100%;
            width: 8%;
            display: flex;
            margin-left: 6px;
            flex-direction: column;

            div.arquibancada {
                background: #ddd;
                cursor: not-allowed;
                flex-grow: 1;
                width: 100%;
                height: 100%;
                border-top-right-radius: 1000vw;
                border-bottom-right-radius: 1000vw;
            }
        }

        div.mid {
            height: 100%;
            width: 84%;

            div.barreira {
                height: 10%;
                width: 100%;
                background: gray;
                display: flex;
                align-items: center;
                justify-content: center;
                color: white;
            }

            div.campo {
                background: url('./../../svg/estadio/campo.png');
                background-size: cover;
                background-repeat: no-repeat;
                background-position: center;
                height: 60%;
                padding-top: 6px;
                padding-bottom: 6px;
                opacity: 0.5;
            }

            div.nivel {
                display: flex;

                div.secao {
                    width: 20%;
                    cursor: pointer;
                    transition: .25s ease;
                    display: flex;
                    color: white;
                    flex-direction: column;

                    @media (max-aspect-ratio: 1/1) {
                        flex-wrap: wrap;
                    }
                    
                    div.setor {
                        flex-grow: 1;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin-right: 2px;
                    }

                    div.setor:not(:only-child):last-child{
                        margin-top: 2px;
                    }

                    div.setor:hover {
                        filter: brightness(1.2);
                    }
                }

                div.secao:last-child > div.setor {
                    margin-right: 0 !important;
                }
            }

            div.nivel-01 {
                height: 20%;

                div.secao > div.setor {
                    background-color: #999;
                }
            }

            div.nivel-02 {
                height: 20%;

                div.secao > div.setor {
                    background-color: #D4AF37;
                }
            }

            div.arquibancada {
                height: 10%;
                background: #ddd;
                cursor: not-allowed;
            }
        }

    }

</style>
